"use strict";

var _regeneratorRuntime = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ethereum_private_key_to_address_1 = __importDefault(require("ethereum-private-key-to-address"));

var ethers = __importStar(require("ethers"));

exports.privateKeyToAddress = ethereum_private_key_to_address_1.default;

exports.wait = function (t) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              return setTimeout(function () {
                return resolve();
              }, t);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

exports.normalizeHex = function (hex, opts) {
  var value = '';

  if (Buffer.isBuffer(hex)) {
    hex = hex.toString('hex');
  }

  if (typeof hex === 'number') {
    hex = hex.toString();
  }

  if (typeof hex === 'string') {
    value = hex.toLowerCase();
  }

  if (value.startsWith('0x')) {
    value = value.slice(2);
  }

  if (value === '') {
    value = '0';
  }

  var data = value.length % 2 ? "0".concat(value) : value;

  if (Buffer.from(data, 'hex')) {
    value = data;
  }

  value = "0x".concat(value);
  return value;
};

exports.signWithPrivateKey = function (message, privateKey, providerUri) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var provider, wallet, data, signature, address;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (privateKey) {
              _context2.next = 2;
              break;
            }

            throw new Error('private key is required');

          case 2:
            provider = new ethers.providers.JsonRpcProvider(providerUri);
            wallet = new ethers.Wallet(privateKey, provider);
            data = message;

            if (message.startsWith('0x')) {
              data = ethers.utils.arrayify(message);
            }

            _context2.next = 8;
            return wallet.signMessage(data);

          case 8:
            signature = _context2.sent;
            address = exports.privateKeyToAddress(privateKey);
            /*
            const verified = verifySignature(message, signature, address)
               if (!verified) {
              throw new Error('signature produced is invalid')
            }
             */

            return _context2.abrupt("return", signature);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

exports.debounce = function (callback, time) {
  var interval;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(interval);
    interval = setTimeout(function () {
      interval = null;
      callback.apply(void 0, args);
    }, time);
  };
};

exports.throttle = function (fn, interval) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var queue = new Map();
  var currentTick = 0;
  var activeCount = 0;

  var throttled = function throttled() {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var timeout;
    return new Promise(function (resolve, reject) {
      var execute = function execute() {
        resolve(fn.apply(_this, args));
        queue.delete(timeout);
      };

      var now = Date.now();

      if (now - currentTick > interval) {
        activeCount = 1;
        currentTick = now;
        timeout = setTimeout(execute, currentTick - now);
      } else if (activeCount < limit) {
        activeCount++;
      } else {
        activeCount = 1;
      }

      queue.set(timeout, reject);
    });
  };

  return throttled;
};